import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { DetailBox } from 'common/components/DetailBox';

import { CreatePasswordForm } from '../forms/CreatePasswordForm';

interface IProps {
    token: string;
    uid: string;
    onSubmit(): void;
}

export const CreatePasswordDetailBox = ({ token, uid, onSubmit }: IProps) => {
    const { t } = useTranslation();

    return (
        <DetailBox
            description={
                <Box component="span">{t('validators.password.invalid')}</Box>
            }
            title={t('account.setPassword.title')}
        >
            <CreatePasswordForm token={token} uid={uid} onSubmit={onSubmit} />
        </DetailBox>
    );
};
